<template>
  <div class="root">
    <div class="login"></div>
  </div>
</template>

<script>
import AuthService from "../services/auth";
export default {
  name: "logout",
  data() {
    return {
      loading: false,
      form: [],
      messages: [],
      login: false
    };
  },
  mounted() {
    localStorage.authToken = null;
    localStorage.removeItem("authToken");
    localStorage.removeItem("userName");
    window.location.href = "/login";
  },
  created() {
    localStorage.authToken = null;
    localStorage.removeItem("authToken");
    localStorage.removeItem("userName");
    window.location.href = "/login";
  },
  methods: {
    logout() {
      AuthService.logout();
    }
  }
};
</script>
<style>
.root {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.login {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}

.login-marg {
  margin-bottom: 10px;
}

.login-button {
  margin-top: 10px;
}
</style>
